import { CREATE_FROM_PLAYLIST_MUTATION, UPDATE_MUTATION, GET_PLAYLIST_OR_LEARNING_PATH_QUERY } from 'academy-common-lib/__generated__/chirp/com/hubspot/learning/center/playlists/rpc/LearningPathChirpService.dfc.new';
import { useMutation } from 'academy-common-lib/utils/DataFetchingClient';
export const useCreateHubspotPlaylistFromPlaylist = ({
  onCompleted
} = {}) => {
  const [createHubspotPlaylistFromPlaylist, {
    loading: createHubspotPlaylistFromPlaylistLoading,
    error: createHubspotPlaylistFromPlaylistError
  }] = useMutation(CREATE_FROM_PLAYLIST_MUTATION, {
    onCompleted
  });
  return {
    createHubspotPlaylistFromPlaylist,
    createHubspotPlaylistFromPlaylistLoading,
    createHubspotPlaylistFromPlaylistError
  };
};
export const useUpdateHubspotPlaylist = ({
  playlistId,
  onCompleted
}) => {
  const [updateHubspotPlaylist, {
    loading: updateHubspotPlaylistLoading,
    error: updateHubspotPlaylistError
  }] = useMutation(UPDATE_MUTATION, {
    onCompleted,
    refetchQueries: [{
      query: GET_PLAYLIST_OR_LEARNING_PATH_QUERY,
      variables: {
        playlistId
      }
    }]
  });
  return {
    updateHubspotPlaylist,
    updateHubspotPlaylistLoading,
    updateHubspotPlaylistError
  };
};